// Rows of the package comparison table on /packages.
// `values` is keyed by package id: true = included, false = not included, string = shown as text.
const packageCompare = {
  title: "Compare Packages",
  subtitle: "See what each package includes at a glance.",
  rows: [
    { label: "Room", values: { 1: "Shared, non-AC", 2: "Twin sharing, AC deluxe", 3: "Single, AC premium", 4: "No stay (OPD)" } },
    { label: "Attached bathroom", values: { 1: true, 2: true, 3: true, 4: false } },
    { label: "24/7 nursing & attendants", values: { 1: true, 2: true, 3: true, 4: false } },
    { label: "Psychiatrist supervision", values: { 1: "Basic", 2: "Regular", 3: "Daily", 4: "Per visit" } },
    { label: "Individual counseling", values: { 1: true, 2: true, 3: true, 4: true } },
    { label: "Group therapy", values: { 1: true, 2: true, 3: "Intensive", 4: false } },
    { label: "Family counseling", values: { 1: false, 2: false, 3: true, 4: false } },
    { label: "Yoga & meditation", values: { 1: false, 2: true, 3: true, 4: false } },
    { label: "Gym & fitness", values: { 1: "Light exercise", 2: true, 3: true, 4: false } },
    { label: "Smart TV & refrigerator", values: { 1: false, 2: true, 3: true, 4: false } },
    { label: "Relapse prevention plan", values: { 1: false, 2: true, 3: "Advanced", 4: false } },
  ],
  calculator: {
    title: "Estimate Your Cost",
    desc: "A quick estimate of room & treatment charges. Medicines, tests and other excluded items are charged separately at actual cost.",
    defaultDays: 30,
    defaultVisits: 4,
  },
};

export default packageCompare;
